import QuizButton, { quizButtonClass } from './QuizButton';

export { quizButtonClass };
export default QuizButton;
